import { useLocomotiveControls } from '@utils'

export function LocomotiveLights() {
  // const spotLeftRef = useRef<SpotLightImpl>(null)
  // const spotRightRef = useRef<SpotLightImpl>(null)

  // const targetLeftRef = useRef<Mesh>(null)
  // const targetRightRef = useRef<Mesh>(null)

  const { radius, position } = useLocomotiveControls()

  // useLayoutEffect(() => {
  //   if (
  //     !spotLeftRef.current ||
  //     !spotRightRef.current ||
  //     !targetLeftRef.current ||
  //     !targetRightRef.current
  //   )
  //     return

  //   spotLeftRef.current.target = targetLeftRef.current
  //   spotRightRef.current.target = targetRightRef.current
  // }, [])

  return (
    <>
      <mesh position={position}>
        <circleGeometry args={[radius]} />
        <meshLambertMaterial emissive="white" emissiveIntensity={3} />
      </mesh>

      <mesh position={[-position[0], position[1], position[2]]}>
        <circleGeometry args={[radius]} />
        <meshLambertMaterial emissive="white" emissiveIntensity={3} />
      </mesh>

      {/* <mesh ref={targetLeftRef} position={[position[0], position[1], position[2] + 1]} visible={false} />
      <mesh
        ref={targetRightRef}
        position={[-position[0], position[1], position[2] + 1]}
        visible={false}
      /> */}

      {/* <SpotLight
        ref={spotLeftRef}
        position={[position[0], position[1], position[2]]}
        attenuation={0.5}
        radiusTop={radius + 0.01}
      />
      <SpotLight
        ref={spotRightRef}
        position={[-position[0], position[1], position[2]]}
        attenuation={0.5}
        radiusTop={radius + 0.01}
      /> */}
    </>
  )
}
